import styled, {css} from 'styled-components';

export const Content = styled.div<{$expanded: boolean; height?: number}>`
  height: 0;

  ${props =>
    props.$expanded &&
    css`
      height: ${props.height}px;
    `};
`;
